import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Info, AlertOctagon, AlertTriangle, AlertCircle } from 'lucide-react';
import { Violation } from '../types';
interface ViolationCardProps {
  violation: Violation;
}
export function ViolationCard({
  violation
}: ViolationCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const severityConfig = {
    Critical: {
      color: 'text-red-700 bg-red-100 ring-red-600/20',
      icon: AlertOctagon
    },
    High: {
      color: 'text-orange-700 bg-orange-100 ring-orange-600/20',
      icon: AlertTriangle
    },
    Medium: {
      color: 'text-amber-700 bg-amber-100 ring-amber-600/20',
      icon: AlertCircle
    },
    Low: {
      color: 'text-slate-700 bg-slate-100 ring-slate-600/20',
      icon: Info
    }
  };
  const {
    color,
    icon: Icon
  } = severityConfig[violation.severity];
  return <div className="bg-white rounded-xl ring-1 ring-slate-200 overflow-hidden transition-shadow hover:shadow-sm" data-id="element-146">
      <button onClick={() => setIsExpanded(!isExpanded)} className="w-full text-left p-4 sm:p-5 flex items-start gap-4 focus:outline-none focus:bg-slate-50 transition-colors" aria-expanded={isExpanded} data-id="element-147">
        <div className="shrink-0 mt-0.5" data-id="element-148">
          <Icon className={`w-5 h-5 ${color.split(' ')[0]}`} data-id="element-149" />
        </div>
        <div className="flex-grow pr-4" data-id="element-150">
          <div className="flex flex-wrap items-center gap-2 mb-1.5" data-id="element-151">
            <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${color}`} data-id="element-152">
              {violation.severity} Severity
            </span>
            <span className="text-xs text-slate-400 font-mono" data-id="element-153">
              Code {violation.code}
            </span>
          </div>
          <h4 className="text-base font-semibold text-slate-900 leading-snug" data-id="element-154">
            {violation.title}
          </h4>
        </div>
        <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-300 mt-1 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-155" />
      </button>

      <AnimatePresence data-id="element-156">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-157">
            <div className="px-4 pb-5 sm:px-5 sm:pb-6 pt-0 border-t border-slate-100 mt-2" data-id="element-158">
              <div className="bg-teal-50 rounded-lg p-4 mt-4 mb-4" data-id="element-159">
                <h5 className="text-sm font-bold text-teal-900 flex items-center gap-2 mb-2" data-id="element-160">
                  <Info className="w-4 h-4 text-teal-600" data-id="element-161" />
                  What this means for you
                </h5>
                <p className="text-sm text-teal-800 leading-relaxed" data-id="element-162">
                  {violation.explanation}
                </p>
              </div>

              <div data-id="element-163">
                <h5 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-164">
                  Inspector's Original Note
                </h5>
                <p className="text-sm text-slate-600 italic border-l-2 border-slate-200 pl-3 py-1" data-id="element-165">
                  "{violation.originalNote}"
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}